import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { EmbeddedApp } from '@shopify/polaris/embedded'

import ShopifyWizard from 'components/shopifyApp/ShopifyWizard'
import ShopifyAppLayout from 'components/shopifyApp/ShopifyAppLayout'
import WizardSkeleton from 'components/shopifyApp/shopifyWizard/Skeleton'

class ShopifyApp extends Component {

  renderBody () {
    const { apps, match } = this.props
    const appId = match.params.appId
    const app = (apps) ? apps[appId] : {}
    if (!app) {
      return (
        <WizardSkeleton></WizardSkeleton>
      )
    }

    return (
      <ShopifyWizard app={app} />
    )
  }

  renderContent () {
    return (
      <ShopifyAppLayout
        body={this.renderBody()}
      />
    )
  }

  render () {
    const { shopifyAuth } = this.props
    // console.log('shopifyAuth', shopifyAuth)
    if (shopifyAuth.apiKey && shopifyAuth.shopUrl) {
      return (
        <EmbeddedApp
          apiKey={shopifyAuth.apiKey}
          shopOrigin={`https://${shopifyAuth.shopUrl}`}
        >
          {this.renderContent()}
        </EmbeddedApp>
      )
    } else {
      return this.renderContent()
    }
  }
}

ShopifyApp.propTypes = {
  apps: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  shopifyAuth: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  apps: state.apps,
  authData: state.authData,
  shopifyAuth: state.shopifyAuth
})

export default connect(mapStateToProps)(ShopifyApp)



// WEBPACK FOOTER //
// ./src/components/pages/ShopifyApp.js